<mat-form-field appearance="outline" class="full-width">
    <mat-label *ngIf="!load">{{label|titlecase}}<span class="required" *ngIf="required">*</span></mat-label>
    <mat-label *ngIf="load">
        <div class="select-placeholder-container">
            <span>{{label|titlecase}}<span class="required" *ngIf="required">*</span></span>
            <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </div>
    </mat-label>
    <mat-select [formControl]="form_control" #select (selectionChange)="optionSelected($event)" (openedChange)="clearSearch()">
        <div class="filter-input multiselect-filter">

            <input matInput #searchInput class="mat-filter-input" [formControl]="searchControl"
                [placeholder]="placeholder" matInput type="search">
            <mat-icon class="clear_icon" *ngIf="searchInput.value!=''" (click)="searchInput.value='';clearSearch()">
                cancel
            </mat-icon>
        </div>
        <div class="" style="margin-top: 10px;" *ngIf="options_display!=''&&options_value!=''">
            <mat-option *ngFor="let data of filteredOptions" [value]="data[options_value]">
                {{data[options_display]}}
            </mat-option>
        </div>
        <div class="" style="margin-top: 10px;" *ngIf="options_display==''&&options_value==''">
            <mat-option *ngFor="let data of filteredOptions" [value]="data">
                {{data}}
            </mat-option>
        </div>


        <mat-option *ngIf="filteredOptions?.length<=0||filteredOptions==undefined">No data found...</mat-option>
    </mat-select>
    <span matSuffix *ngIf="form_control.hasError('required') && form_control.touched" matTooltip="{{error_message }}"
        [matTooltipDisabled]="!form_control.invalid">
        <mat-icon color="warn">info</mat-icon>
    </span>
</mat-form-field>